import { ShieldAlert } from "lucide-react";
import {
  ExposureRiskReviewParamsSchema,
  defaultExposureRiskReviewParams,
  type ExposureRiskReviewParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ExposureRiskReviewWidget, RISK_VISIBLE_LIMIT } from "./Component.js";
import { ExposureRiskReviewExpandedEditor } from "./ExpandedEditor.js";

export const exposureRiskReviewDef: WidgetDef<ExposureRiskReviewParams> = {
  kind: "exposureRiskReview",
  label: "Exposure & Risk Review",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 752, h: 384 },
  defaultParams: defaultExposureRiskReviewParams,
  Component: ExposureRiskReviewWidget,
  ExpandedComponent: ExposureRiskReviewExpandedEditor,
  storage: "sql",
  schema: ExposureRiskReviewParamsSchema,
  accent: "amber",
  icon: ShieldAlert,
  subtitle: "Review immediate exposure and containment risk",
  defaultRoster: true,
  category: "single",
  layout: { col: "full", row: 1, width: 752, height: 360 },
  expandable: true,
  renderFooter: (data) => ({
    left: `Showing ${Math.min(RISK_VISIBLE_LIMIT, data.risks.length)} of ${data.risks.length} · Expand to view all`,
    right: "Sorted by criticality",
  }),
};

registerWidget(exposureRiskReviewDef);
